import { render, staticRenderFns } from "./site-instant-charge-confirmation.vue?vue&type=template&id=ef56b8e0&"
import script from "./site-instant-charge-confirmation.vue?vue&type=script&lang=js&"
export * from "./site-instant-charge-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports